import { TransactionSearchPayload } from 'app/modules/search/payload';
import { GetTransactionsPayload } from 'app/modules/transactions/requests';
import {
  ActionEventExternalId,
  TxnEventExternalId,
} from 'app/shared/types/eventExternalIds';

const BASE = ['transactions'];

export const TRANSACTION_QUERY_KEYS = {
  getTransactions: (payload: GetTransactionsPayload) =>
    [...BASE, payload] as const,
  getTransactionById: (id?: string, useCacheEndpoint?: boolean) => {
    if (id === undefined) {
      return [...BASE, 'txn-details'] as const;
    }
    if (useCacheEndpoint) {
      return [...BASE, 'txn-details', id, useCacheEndpoint] as const;
    }
    return [...BASE, 'txn-details', id] as const;
  },
  getCheckImageTransactions: (id?: string) =>
    [...BASE, 'checkImageTransaction', id] as const,
  getTxnShadowEvaluation: (id?: TxnEventExternalId | ActionEventExternalId) =>
    [...BASE, 'shadowEvaluationLog', id] as const,
  getTransactionSearch: (payload?: TransactionSearchPayload) =>
    payload
      ? ([...BASE, 'search', payload] as const)
      : ([...BASE, 'search'] as const),
};
